import { connect } from "react-redux";
import { ApplicationStore } from "src/store";
import { setGarageCreated } from "src/store/actions/onlineShopper";
import { toggleFlyout } from "src/store/actions/onlineShopper/flyout";
import { setSignIn } from "src/store/actions/onlineShopper/signIn";
import { toggleModal } from "src/store/actions/openModal";
import { FlyoutGarage } from "./FlyoutGarage";
import { setLocalDealState } from "src/utils/localStorage";

export function mapStateToProps({ onlineShopper, vehicles, account, deal }: ApplicationStore) {
    return {
        account,
        uuid: deal.uuid!,
        env: onlineShopper.env,
        isAuthed: onlineShopper.isAuthed,
        vehicles: Object.values(vehicles.entities),
    };
}

const mapDispatchToProps = (dispatch: any) => ({
    signIn: () => {
        dispatch(toggleFlyout());
        dispatch(toggleModal());
        dispatch(setSignIn({ routeSignIn: true }));
    },
    toggleOSModal: (slug: string, env: string, dealUuid: string) => {
        setLocalDealState({ slug, env, uuid: dealUuid, garageCreated: true, isAuthed: true });
        dispatch(setGarageCreated());
        dispatch(toggleFlyout());
        dispatch(toggleModal("lg"));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(FlyoutGarage);
